import moment from 'moment';
import { IConversation } from 'redhotpie-shared-lib/interfaces/IConversation';
import { IMessage } from 'redhotpie-shared-lib/interfaces/IMessage';
import boostServices from 'redhotpie-shared-lib/services/boostServices';
import configApp from '../../app.json';
import * as types from '../constants/actionTypes';
import * as CONSTANTS from '../constants/constants';
import { PAGING_DEFAULT, RHP_ERROR_CODE } from '../constants/constants';
import { TYPE_MESSAGE } from '../constants/notificationTypes';
import * as messageUtils from '../functions/messageUtils';
import { addPrefixAndSuffix, checkTimeValid } from '../functions/messageUtils';
import * as utils from '../functions/utils';
import { Dispatch } from '../hooks/useRedux';
import { IAction } from '../interfaces/IAction';
import { IApiResponse } from '../interfaces/IApiResponse';
import WebIM from '../libs/webIM';
import WebIMConfig from '../libs/webIMConfig';
import conversationService from '../services/conversationService';
import locationService from '../services/locationService';
import userService from '../services/userService';
import * as myStore from '../store/myStore';
import { getServerTime } from './commonStateAction';
import * as conversationDetailAction from './conversationDetailAction';
import { getClubsCanBeInvited } from './groupActions';
import { getGroupsCanBeInvited } from './groupChatActions';
import * as messageActions from './messageActions';
import { removeStatusErrorMessage, updateMessageErrorSuccess } from './messageActions';
import * as userActions from './userActions';
import { IPeerVcard } from 'redhotpie-shared-lib/models/conversation';

const isNative = !configApp || !configApp.isWebApp;

export interface ExtraParam {
  mediaId?: number;
  mediaType?: string;
  messageObject?: any;
}

interface MessageDetail {
  MsgType: string;
  Data: any;
  MsgId: string;
  Time: string;
  ChatType: string;
  ConvId: string;
  ToJid?: string;
}

export function toggleAlertConversationsFilter(show: boolean = false): IAction {
  return { type: types.SHOW_ALERT_CONVERSATIONS_FILTER, data: show };
}

export function updateServerTimeGroupChat(time: number): IAction {
  return { type: types.UPDATE_SERVER_TIME_GROUP_CHAT_SUCCESS, data: time };
}

export function updateChatServerTime(time: number): IAction {
  return { type: types.UPDATE_CHAT_SERVER_TIME, data: time };
}

export function loadMoreConversationsSuccess(): IAction {
  return { type: types.LOAD_MORE_CONVERSATIONS };
}

export function resetConversation(): IAction {
  return { type: types.RESET_CONVERSATIONS };
}

export function resetPageNumberConversation(): IAction {
  return { type: types.RESET_PAGE_NUMBER_CONVERSATIONS };
}

export function loadMoreConversationsFailure(): IAction {
  return { type: types.LOAD_MORE_CONVERSATIONS_FAILURE };
}

export function toggleAutoSelectFirstConversation(toggle: boolean = false): IAction {
  return { type: types.TOGGLE_AUTO_SELECT_CONVERSATION, toggle };
}

export function updateFilterParamByDefaultFolderSuccess(defaultFolder: string): IAction {
  return {
    type: types.UPDATE_FILTER_PARAMS_BY_DEFAULT_FOLDER,
    data: defaultFolder,
  };
}

export function resetGetOrCreateError(): IAction {
  return { type: types.RESET_GET_OR_CREATE_ERROR };
}

export function loadMainAvatarsSuccess(data: any): IAction {
  return { type: types.LOAD_MAIN_AVATARS_SUCCESS, data };
}

export function getConversationRequest(params: any): IAction {
  return { type: types.LOAD_CONVERSATIONS_REQUEST, params };
}

export function getNewConversationSuccess(): IAction {
  return { type: types.LOAD_NEW_CONVERSATIONS_SUCCESS };
}

export function patchRulesGroupChatSuccess(params: any): IAction {
  return { type: types.PATCH_RULES_GROUP_CHAT_SUCCESS, params };
}

export function getConversationSuccess(
  data: any,
  totalCount: number,
  isStatementShown: boolean = false,
  isLoggingEnabled: boolean
): IAction {
  const { matchingUsers } = myStore.getStore().getState().loginReducer;
  return {
    type: types.LOAD_CONVERSATIONS_SUCCESS,
    data,
    totalCount,
    matchingUsers,
    isStatementShown,
    isLoggingEnabled,
  };
}

export function updateDiffConversationSuccess(data: any): IAction {
  return { type: types.UPDATE_DIFF_CONVERSATIONS_SUCCESS, data };
}

export function getConversationFailure(params: any): IAction {
  return { type: types.LOAD_CONVERSATIONS_FAILURE, params };
}

export function retryApiFailStateSuccess(): IAction {
  return { type: types.RETRYING_API_FAIL_SUCCESS };
}

export function retryApiFailState(): IAction {
  return { type: types.RETRYING_API_FAIL };
}

export function updateLoadMoreStatus(data: any): IAction {
  return { type: types.UPDATE_LOAD_STATUS, data };
}

export function updateLastSyncTime(data: any): IAction {
  return { type: types.UPDATE_LASTTIME_SYNC, data };
}

export function updateConversationSuccess(
  peerXpppId: string,
  chatMessage: any,
  unreadCountIncrement: number = 0,
  isForwardedMessage: boolean
): IAction {
  const { xmppId } = myStore.getStore().getState().loginReducer.userInfo;
  return {
    type: types.UPDATE_CONVERSATION_SUCCESS,
    peerXpppId,
    chatMessage,
    unreadCountIncrement,
    isForwardedMessage,
    xmppId,
  };
}

export function toggleDateFinderAndEvent(data: any): IAction {
  return { type: types.TOGGLE_OPTION_DATE_FINDER_EVENT, data };
}

export function deleteConversationLastMessageSuccess(peerXpppId: string, msgId: string): IAction {
  return { type: types.DELETE_CONVERSATION_LAST_MESSAGE_SUCCESS, peerXpppId, msgId };
}

export function selectPeerVcardSuccess(selectedPeerVcard: any): IAction {
  return { type: types.SELECT_PEERVCARD_SUCCESS, selectedPeerVcard };
}

export function selectPeerVcardRequest(): IAction {
  return { type: types.SELECT_PEERVCARD_REQUEST };
}

export function selectPeerVcardFailed(): IAction {
  return { type: types.SELECT_PEERVCARD_FAILED };
}

export function setReadConversationRequest(params: any): IAction {
  return { type: types.SET_READ_CONVERSATION_REQUEST, params };
}

export function setReadConversationSuccess(): IAction {
  return { type: types.SET_READ_CONVERSATION_SUCCESS };
}

export function setReadConversationFailure(): IAction {
  return { type: types.SET_READ_CONVERSATION_FAILURE };
}

export function resetConversationUnreadCountSuccess(selectedPeerVcard: any, matchingUsers: any): IAction {
  return {
    type: types.RESET_CONVERSATION_UNREAD_COUNT_SUCCESS,
    selectedPeerVcard,
    matchingUsers,
  };
}

export function resetSelectedPeerVcardAndConversationInfoSuccess(): IAction {
  return { type: types.RESET_SELECTED_PEERVCARD_AND_CONVERSATION_INFO_SUCCESS };
}

export function getConversationsUnreadCountSuccess(matchingUsers: any, items: any): IAction {
  return { type: types.GET_CONVERSATIONS_UNREAD_COUNT, matchingUsers, items };
}

export function getOrCreateConversationRequest(): IAction {
  return { type: types.CREATE_CONVERSATION_REQUEST };
}

export function getOrCreateConversationFailure(): IAction {
  return { type: types.CREATE_CONVERSATION_FAILURE };
}

export function getOrCreateConversationSuccess(conversation: IConversation): IAction {
  const { matchingUsers } = myStore.getStore().getState().loginReducer;
  return {
    type: types.CREATE_CONVERSATION_SUCCESS,
    data: conversation,
    matchingUsers,
  };
}

export function filterConversationSuccess(
  keyword: string,
  primaryIndex: number,
  secondaryIndex: number,
  isNative: boolean,
  isMatchDefault: boolean
): IAction {
  return {
    type: types.FILTER_CONVERSATIONS,
    data: { keyword, primaryIndex, secondaryIndex, isNative, isMatchDefault },
  };
}

export function getConversationStatusRequest(): IAction {
  return { type: types.GET_CONVERSATION_STATUS_REQUEST };
}

export function getConversationStatusFailure(): IAction {
  return { type: types.GET_CONVERSATION_STATUS_FAILURE };
}

export function getConversationStatusSuccess(data: any): IAction {
  return { type: types.GET_CONVERSATION_STATUS, data };
}

export function updateMemberLevelConversationSelected(xmppId: string, memberLevel: number): IAction {
  return {
    type: types.UPDATE_MEMBER_LEVEL_CONVERSATION_SELECTED,
    data: { xmppId, memberLevel },
  };
}

export function checkConversationPinStatus(): IAction {
  return { type: types.CHECK_PIN_STATUS_CONVERSATION_SELECTED, data: {} };
}

export function updateConversation(data: any): IAction {
  return { type: types.UPDATE_CONVERSATION, data };
}

export function updateMemberCount(data: any): IAction {
  return { type: types.UPDATE_MEMBER_COUNT, data };
}

export function savePeerVcard(data: any): IAction {
  return { type: types.SAVE_PEEVCARD, data };
}

export function updateConversationUnreadCount(peerJid: string): IAction {
  const { matchingUsers } = myStore.getStore().getState().loginReducer;
  return { type: types.UPDATE_CONVERSATION_UNREAD, peerJid, matchingUsers };
}

export function hiddenStatementRead(): IAction {
  return { type: types.HIDDEN_STATEMENT_READ };
}

export function updateParticipantCount({ roomJid, count }: { roomJid: string; count: number }): IAction {
  return { type: types.UPDATE_PARTICIPANT_COUNT, roomJid, count };
}

export function updateStatementRead() {
  const params = {
    isStatementRead: true,
  };
  return (dispatch: Dispatch) => {
    dispatch(hiddenStatementRead());
    conversationService.updateStatementRead(params);
  };
}

export const getConversations = (params?: any) => (dispatch: Dispatch, getState: any) => {
  dispatch(getConversationRequest(params));
  return conversationService
    .getConversations(params)
    .then((response: IApiResponse) => {
      if (!response.success) {
        dispatch(getConversationFailure({ isGetFullConversations: true }));
        return response;
      }

      if (response.data.items && response.data.items.length > 0) {
        const conversationsGroup: IConversation[] = response.data.items.filter((c: IConversation) => c?.isGroup);
        if (conversationsGroup && conversationsGroup.length > 0) {
          const { roomJidsJoinedSuccess } = getState().conversationsReducer;
          const roomJids = conversationsGroup
            .filter(c => c.peerVcard.xmppId && !roomJidsJoinedSuccess.includes(c.peerVcard.xmppId))
            .map(c => c.peerVcard.xmppId);
          roomJids.forEach((roomJid: string) => {
            dispatch(joinPrivateGroup(roomJid));
          });
        }

        if (WebIMConfig.preloadConversationDetail) {
          // get detail each conversation
          const loginUser = myStore.getStore().getState().loginReducer.userInfo;
          response.data.items.forEach((conversation: IConversation) => {
            conversationService
              .getConversationsDetails(conversation.peerVcard.xmppId, loginUser, conversation.peerVcard, {
                pageSize: CONSTANTS.PAGING_DEFAULT.PAGE_SIZE_MESSAGE,
              })
              .then(responseConversationsDetails => {
                const { success, data } = responseConversationsDetails;
                if (!success && data && data.items.length) {
                  dispatch(conversationDetailAction.getConversationDetailSuccess(data.items));
                }
              })
              .catch(f => f);
          });
        }
      }

      dispatch(
        getConversationSuccess(
          response.data.items,
          response.data.totalCount,
          response.data.isStatementShown,
          response.data.isLoggingEnabled
        )
      ); // response.data.isStatementShown
      // dispatch(getConversationsUnreadCount(response.data.items));

      // dispatch(messageSummaryActions.updateUnreadMessageAllSuccess());
      // return dispatch(getConversationSuccess(response.data.items, response.data.totalCount));

      return response;
    })
    .catch(() => dispatch(getConversationFailure({ isGetFullConversations: true })));
};

export const getNewConversations = (lastSynchAt: any, isGetNewConversation: boolean) => (dispatch: Dispatch, getState: any) => {
  dispatch(getConversationRequest({}));
  return conversationService
    .getNewConversations(typeof lastSynchAt === 'object' ? lastSynchAt.getTime?.() : lastSynchAt, isGetNewConversation)
    .then((response: IApiResponse) => {
      if (!response?.success) {
        return dispatch(getConversationFailure({}));
      }

      // console.log("response.data",response);
      if (response.data && response.data.items.length > 0) {
        // const dataConversation = myStore.getStore().getState().conversationsReducer.data;
        // dataNewConversation && dataNewConversation.map((dataNewItem,index)=>{
        //   let existIndex = dataConversation.findIndex(dataItem => dataItem.id === dataNewItem.id);
        //   if(existIndex === -1) {
        //     dataUpdate.push(dataNewItem);
        //   }else{
        //     const dataNew =  dataConversation.map((dataItem)=>{
        //       if(dataItem.id === dataNewItem.id){
        //         dataItem = dataNewItem;
        //       }
        //       return dataItem;
        //     });
        //     if(index === dataNewConversation.length - 1){
        //       dataUpdate = [...dataNew];
        //     }
        //   }
        // });
        // console.log("dataConversation",dataConversation,dataNewConversation,dataUpdate);
        if (WebIMConfig.preloadConversationDetail) {
          // get detail each conversation
          const loginUser = myStore.getStore().getState().loginReducer.userInfo;
          response.data.items.forEach((conversation: IConversation) => {
            conversationService
              .getConversationsDetails(conversation.peerVcard.xmppId, loginUser, conversation.peerVcard, {
                pageSize: CONSTANTS.PAGING_DEFAULT.PAGE_SIZE_MESSAGE,
              })
              .then(responseConversationsDetails => {
                const { success, data } = responseConversationsDetails;
                if (!success && data && data.items.length) {
                  dispatch(conversationDetailAction.getConversationDetailSuccess(data.items));
                }
              })
              .catch(f => f);
          });
        }
        if (response.data.items && response.data.items.length > 0) {
          const conversationsGroup: IConversation[] = response.data.items.filter((c: IConversation) => c?.isGroup);
          if (conversationsGroup && conversationsGroup.length > 0) {
            const { roomJidsJoinedSuccess } = getState().conversationsReducer;
            const roomJids = conversationsGroup
              .filter(c => c.peerVcard.xmppId && !roomJidsJoinedSuccess.includes(c.peerVcard.xmppId))
              .map(c => c.peerVcard.xmppId);
            roomJids.forEach(roomJid => {
              dispatch(joinPrivateGroup(roomJid));
            });
          }
        }
        // dispatch(messageSummaryActions.updateUnreadMessageAllSuccess());
      }
      dispatch(updateDiffConversationSuccess(response.data.items));
      dispatch(getNewConversationSuccess());
      return response;
    })
    .catch((e: any) => {
      console.log('error', e);
      dispatch(getConversationFailure({}));
    });
};

export function selectPeerVcardAsync(
  userId: number,
  loginUser: any,
  isMobileWeb: boolean,
  chatted: boolean,
  isFromProfile: boolean,
  isRetry: boolean
) {
  return (dispatch: Dispatch) => {
    dispatch(selectPeerVcardRequest());
    return userService.getProfileSummary(userId).then((res: any) => {
      if (res.success) {
        const peerVcard = res.data;
        if (loginUser && peerVcard && loginUser && loginUser.xmppId && peerVcard.xmppId) {
          if (chatted) {
            if (!isRetry) {
              dispatch(conversationDetailAction.getConversationDetailRequest(peerVcard.xmppId));
            }
            dispatch(
              conversationDetailAction.getConversationDetails(loginUser, peerVcard, {
                pageSize: PAGING_DEFAULT.PAGE_SIZE_MESSAGE,
                lastSynchAt: 0,
              })
              // @ts-ignore
            ).then(() => {
              const timeOutLoaded = setTimeout(() => {
                clearTimeout(timeOutLoaded);
                dispatch(conversationDetailAction.getConversationDetailRequestSuccess());
              }, 650);
            });
          } else {
            if (!isRetry) {
              dispatch(conversationDetailAction.getConversationDetailRequestSuccess());
            }
          }
        } else {
          console.log('Missing the info to get the peerVcard detail', loginUser, peerVcard);
        }

        dispatch(selectPeerVcardSuccess(peerVcard));

        if (!peerVcard.id && peerVcard.xmppId) {
          userService.getQuickProfileByXmppId(peerVcard.xmppId).then(res => {
            if (res.success) {
              peerVcard.id = res.data.id;
              dispatch(setReadConversation(res.data));
            } else {
              console.log('Error: conversationInboxAction/selectPeerVcard/getQuickProfileByXmppId', res.message);
            }
          });
        } else {
          dispatch(setReadConversation(peerVcard));
        }
        userService.getActiveSubmissionCount({ userId }).then(res => {
          if (res.success) {
            dispatch(toggleDateFinderAndEvent(res.data));
          }
        });

        // send message all read
        dispatch(messageActions.readAll(peerVcard.xmppId, [], peerVcard.isGroup));

        // Get conversation status
        if (!peerVcard.isGroup) {
          dispatch(getConversationStatus(peerVcard.userId, isMobileWeb, peerVcard.xmppId));
          dispatch(getGroupsCanBeInvited(peerVcard.userId));
        }
        // // Check is matching profile
        // Check pin conversation from Friend & Favorite
        dispatch(checkConversationPinStatus());
        return res;
      }
      dispatch(selectPeerVcardFailed());

      if (res?.data?.ResponseStatus?.ErrorCode === RHP_ERROR_CODE.CODE_1003.ErrorCode) {
        WebIMConfig.onProfileSummaryNotFound?.();
      }

      console.log('ERROR: userAction/checkMatchingProfile', res.message);
      return res;
    });
  };
}

export function selectPeerVcard(
  peerVcardParam: IPeerVcard,
  loginUser: any,
  isMobileWeb: boolean,
  chatted?: boolean,
  isFromProfile?: boolean,
  isRetry?: boolean
) {
  WebIMConfig.isUserInValid = false;
  return async (dispatch: Dispatch) => {
    dispatch(selectPeerVcardRequest());
    dispatch(getServerTime());
    const peerVcard = { ...peerVcardParam };
    if (loginUser && peerVcard && loginUser.xmppId && peerVcard.xmppId) {
      // if (chatted) {
      if (!isRetry) {
        dispatch(conversationDetailAction.getConversationDetailRequest(peerVcard.xmppId));
      }
      dispatch(
        conversationDetailAction.getConversationDetails(loginUser, peerVcard, {
          pageSize: PAGING_DEFAULT.PAGE_SIZE_MESSAGE,
          lastSynchAt: 0,
        })
      ).then(() => {
        const timeOutLoaded = setTimeout(() => {
          clearTimeout(timeOutLoaded);
          dispatch(conversationDetailAction.getConversationDetailRequestSuccess());
        }, 650);
      });
      // } else {
      //   if (!isRetry) {
      //     dispatch(conversationDetailAction.getConversationDetailRequestSuccess());
      //   }
      // }
    } else {
      console.log('Missing the info to get the peerVcard detail', loginUser, peerVcard);
    }

    if (peerVcard) {
      dispatch(selectPeerVcardSuccess(peerVcard));

      const getActiveSubmissionCountPeerVcard = () => {
        userService.getActiveSubmissionCount({ userId: peerVcard.userId }).then(res => {
          if (res.success) {
            dispatch(toggleDateFinderAndEvent(res.data));
          }
        });
      };

      if (
        peerVcard &&
        !peerVcard.isGroup &&
        (peerVcard.avatarFullUrl === '' || peerVcard.avatarUrl === '' || !peerVcard.dealBreakerConflict)
      ) {
        userService.getProfileSummary(peerVcard.userId).then(res => {
          if (res.success) {
            const param = isNative
              ? {
                  ...res.data,
                  userType: peerVcard && peerVcard.userType,
                }
              : { ...res.data };
            dispatch(selectPeerVcardSuccess(param));
          } else {
            console.log('ERROR: userAction/checkMatchingProfile', res.message);
            if (res?.data?.ResponseStatus?.ErrorCode === RHP_ERROR_CODE.CODE_1003.ErrorCode) {
              WebIMConfig.onProfileSummaryNotFound?.();
              WebIMConfig.isUserInValid = true;
            }
          }
          getActiveSubmissionCountPeerVcard();
        });
      } else {
        getActiveSubmissionCountPeerVcard();
      }

      if (!peerVcard.id && peerVcard.xmppId && !peerVcard.isGroup) {
        userService.getQuickProfileByXmppId(peerVcard.xmppId).then(res => {
          if (res.success) {
            peerVcard.id = res.data.id;
            // if(chatted) {
            dispatch(setReadConversation(res.data));
            // }
          } else {
            console.log('Error: conversationInboxAction/selectPeerVcard/getQuickProfileByXmppId', res.message);
          }
        });
      } else {
        // if(chatted)
        dispatch(setReadConversation(peerVcard));
      }

      // send message all read
      // if (chatted){
      // if (!peerVcard.isGroup) {
      dispatch(messageActions.readAll(peerVcard.xmppId, [], peerVcard.isGroup));
      // }
      // }
      // Get conversation status
      if (!peerVcard.isGroup) {
        dispatch(getClubsCanBeInvited(peerVcard.userId));
        dispatch(getConversationStatus(peerVcard.userId, isMobileWeb, peerVcard.xmppId));
        dispatch(getGroupsCanBeInvited(peerVcard.userId));
      }
      // // Check is matching profile
      // Check pin conversation from Friend & Favorite
      dispatch(checkConversationPinStatus());
    } else {
      dispatch(selectPeerVcardFailed());
      console.warn('peerVcard is missing peerVcard');
    }
  };
}

export function setReadConversation(peerVcard: any) {
  return (dispatch: Dispatch) => {
    dispatch(setReadConversationRequest({}));
    return conversationService
      .resetConversationUnreadCount(peerVcard.id, addPrefixAndSuffix(peerVcard.xmppId))
      .then((res: any) => {
        if (res.success) {
          dispatch(setReadConversationSuccess());
          return dispatch(resetConversationUnreadCount(peerVcard));
        }
        // else {
        //   console.log("Error: conversationInboxAction/selectPeerVcard/resetConversationUnreadCount", res.message);
        // }
        return dispatch(setReadConversationFailure());
      })
      .catch((e: any) => {
        console.log('catch exception', e);
        dispatch(setReadConversationFailure());
      });
  };
}

function isExistedConversation(peerJid: string) {
  const conversations: IConversation[] = myStore.getStore().getState().conversationsReducer.data;
  if (conversations && conversations.length > 0) {
    const isExisted = conversations.findIndex(x => x.peerVcard.xmppId === peerJid.toString());
    return isExisted !== -1;
  }
  return false;
}

export function resetSelectedConversation() {
  return (dispatch: Dispatch) => {
    dispatch(resetSelectedPeerVcardAndConversationInfoSuccess());
  };
}

export function updateUnreadAndLastMessage(lastXmppMessage: any, isForwardedMessage: boolean = false) {
  return (dispatch: Dispatch) => {
    const loginXmppId = myStore.getStore().getState().loginReducer.userInfo.xmppId;
    const peerJid = lastXmppMessage.to !== loginXmppId ? lastXmppMessage.to : lastXmppMessage.from;
    const chatMessage = messageUtils.convertMsgXmppToChatMessageModel(lastXmppMessage);
    dispatch(updateConversationSuccess(peerJid, chatMessage, isForwardedMessage ? 0 : 1, isForwardedMessage));
  };
}

export function updateDataLastMessageSuccess(convId: number, message: IMessage) {
  return { type: types.CHAT_EDIT_LAST_MESSAGE_CONVERSATION_SUCCESS, convId, message };
}

export function updateLastMessageConversation(lastXmppMessage: any) {
  return (dispatch: Dispatch) => {
    const peerJid = lastXmppMessage.to;
    dispatch(updateConversationSuccess(peerJid, lastXmppMessage, 1, false));
  };
}

export function resetConversationUnreadCount(peerVcard: any) {
  const { matchingUsers } = myStore.getStore().getState().loginReducer;
  return (dispatch: Dispatch) => {
    dispatch(resetConversationUnreadCountSuccess(peerVcard, matchingUsers));
  };
}

export function getConversationsUnreadCount(items: any) {
  const { matchingUsers } = myStore.getStore().getState().loginReducer;
  return (dispatch: Dispatch) => {
    dispatch(getConversationsUnreadCountSuccess(matchingUsers, items));
    // return conversationService.getConversationUnreadCount(xmppId).then((res) => {
    //   if (res.success) {
    //     dispatch(getConversationsUnreadCountSuccess(res.data.unreadCount));
    //   }
    //   else {
    //     console.log("ERROR: conversationInboxAction/getConversationsUnreadCount", res.message);
    //   }
    //   return res;
    // });
  };
}

export function getOrCreateConversation(peerJid: string, cb?: () => void, isMatch?: boolean) {
  return (dispatch: Dispatch) => {
    dispatch(getOrCreateConversationRequest());
    return conversationService
      .getOrCreateConversation(peerJid)
      .then(res => {
        if (res.success && res.data) {
          if (isMatch !== null && isMatch !== undefined) {
            const conversation = res.data;
            conversation.peerVcard.isMatch = isMatch;
          }
          dispatch(getOrCreateConversationSuccess(res.data));
          if (cb) {
            cb();
          }
        } else {
          dispatch(getOrCreateConversationFailure());
        }
        // else {
        //   console.log("ERROR: conversationInboxAction/getOrCreateConversation", res.message);
        // }
        return res;
      })
      .catch(() => {
        dispatch(getOrCreateConversationFailure());
        return { success: false, data: null };
      });
  };
}

export function filterConversations(
  keyword: string,
  primaryIndex: number,
  secondaryIndex: number,
  isNative?: boolean,
  isMatchDefault?: boolean
) {
  return (dispatch: Dispatch) => {
    const defaultFolderIsMatching =
      isMatchDefault ||
      (myStore.getStore().getState().loginReducer.userInfo.messenger &&
        myStore.getStore().getState().loginReducer.userInfo.messenger.defaultFolder !== CONSTANTS.DEFAULT_FOLDER_OPTION.ALL);
    dispatch(filterConversationSuccess(utils.removeSpace(keyword), primaryIndex, secondaryIndex, !!isNative, defaultFolderIsMatching));
  };
}

export function updateFilterParamByDefaultFolder(defaultFolder: string) {
  return (dispatch: Dispatch) => {
    dispatch(updateFilterParamByDefaultFolderSuccess(defaultFolder));
  };
}

export function getConversationStatus(userId: number, isMobileWeb: boolean, xmppId: string) {
  return (dispatch: Dispatch) => {
    dispatch(getConversationStatusRequest());
    return conversationService
      .getConversationStatus(userId, isMobileWeb)
      .then(res => {
        if (res && res.success) {
          if (!isExistedConversation(xmppId)) {
            dispatch(getOrCreateConversation(xmppId, undefined, res.data.isSenderMatching));
          } else {
            dispatch(resetGetOrCreateError());
          }
          dispatch(userActions.checkMatchingProfileSuccess(res.data.isRecvMatching, xmppId));
          dispatch(getConversationStatusSuccess(res.data));
          dispatch(updateMemberLevelConversationSelected(xmppId, res.data.receiverMemberLevel));
        } else {
          dispatch(getConversationStatusFailure());
          console.log('ERROR: conversationDetailAction/getConversationStatus', res.message);
        }
        return res;
      })
      .catch(() => dispatch(getConversationStatusFailure()));
  };
}

export function checkIfCanSendMessage(userId: number) {
  return (dispatch: Dispatch) => {
    return conversationService.checkIfCanSendMessage(userId).then(res => {
      dispatch(getConversationStatusSuccess(res.data));
      if (res && !res.success) {
        console.log('ERROR: conversationDetailAction/getConversationStatus', res.message);
      }
      return res;
    });
  };
}

export function notifyMessageSentGroupChat(messageData: any, roomJid: string, extraParam: ExtraParam) {
  return (dispatch: Dispatch) => {
    return conversationService.notifyMessageSentGroupChat(messageData, roomJid, extraParam).then(res => {
      // get message id from extraParam
      const {
        messageObject: { id },
      } = extraParam;
      if (!res || !res.success) {
        dispatch(updateMessageErrorSuccess(id));
        console.error('ERROR: conversationDetailAction/notifyMessageSent', res?.message);
      } else {
        dispatch(removeStatusErrorMessage(id));
      }
      return res;
    });
  };
}

export function notifyMessageSent(
  receiverId: string,
  message: string,
  notificationType: number = TYPE_MESSAGE,
  convKey: string,
  extraParam: ExtraParam
) {
  return (dispatch: Dispatch, getState: any) => {
    const data: IConversation[] = getState().conversationsReducer.data || [];
    const { userId } = getState().loginReducer.userInfo;
    const selectedConversationInfo = getState().conversationsReducer.selectedConversationInfo;
    const conversationKey = convKey || selectedConversationInfo.conversationKey;
    // Update local conversation boost expiry time
    const conversationInfo = data.find(x => x.id === selectedConversationInfo?.id);
    const profileBoostExpiry = getState().loginReducer?.userInfo?.profileBoostExpiry || null;
    const conversationBoostExpiry = conversationInfo?.userBoostExpiryAt || null;
    let boostExpiryTime = null;
    if (profileBoostExpiry) {
      if (conversationBoostExpiry) {
        if (moment(conversationBoostExpiry).isBefore(profileBoostExpiry)) {
          boostExpiryTime = moment(profileBoostExpiry).unix() * 1000;
        }
      } else {
        boostExpiryTime = moment(profileBoostExpiry).unix() * 1000;
      }
    }
    return conversationService.notifyMessageSent(receiverId, message, notificationType, conversationKey, extraParam).then(res => {
      // get message id from extraParam
      const {
        messageObject: { id },
      } = extraParam;
      if (res && res.success) {
        // dispatch(userActions.checkMatchingProfileSuccess(res.data.isRecvMatching, xmppId));
        dispatch(getConversationStatusSuccess(res.data));
        // dispatch(updateMemberLevelConversationSelected(xmppId, res.data.receiverMemberLevel));
        dispatch(removeStatusErrorMessage(id));
        // Update Conversation boost expiry time
        if (boostExpiryTime) {
          dispatch(updateConversationUserBoostExpiryTime(selectedConversationInfo.id, boostExpiryTime));
          boostServices
            .notifyBoostMySelf({
              fromUserId: `${userId}`,
              fromUserJid: addPrefixAndSuffix(userId),
              toUserId: receiverId,
              type: 'Boosting',
              action: {
                name: 'BoostMySelf',
              },
              data: {
                status: {
                  userBoostExpiryAt: boostExpiryTime,
                  convId: selectedConversationInfo.id,
                },
              },
            })
            .then(res => {
              console.log('res', res);
            });
        }
      } else {
        dispatch(updateMessageErrorSuccess(id));
        console.error('ERROR: conversationDetailAction/notifyMessageSent', res?.message);
      }
      return res;
    });
  };
}

export function loadMoreConversations() {
  return (dispatch: Dispatch) => {
    dispatch(loadMoreConversationsSuccess());
  };
}

export function loadMainAvatars(userIds: number[]) {
  return (dispatch: Dispatch) => {
    const data: any = [];
    const timeout = undefined;
    let countComplete = 0;
    userIds.forEach(id => {
      clearTimeout(timeout);

      // setTimeout(()=>{
      userService
        .getMainPhoto(id)
        .then(res => {
          if (res.success && res.data && !utils.isEmptyString(res.data.thumbUrl)) {
            data.push({ data: res.data, userId: id });
          } else {
            // eslint-disable-next-line no-throw-literal
            throw new Error('fail');
          }
        })
        .catch(() => {
          data.push({ data: 'error', userId: id });
        })
        .finally(() => {
          countComplete++;
          // console.log("countComplete:",countComplete);
          if (countComplete === userIds.length) {
            dispatch(loadMainAvatarsSuccess(data));
          }
        });
      // },countComplete * 1000);
    });
  };
}

export function updateReadLastMessage(mid: string, peerUserXmppId: string = '') {
  return (dispatch: Dispatch) => {
    const xmppId = messageUtils.removeJidResource(messageUtils.removePrefixAndSuffix(peerUserXmppId)) || '';
    dispatch(updateReadLastMessageSuccess(mid, xmppId));
  };
}

export function updateReadLastMessageSuccess(mid: string, peerUserXmppId: string = ''): IAction {
  return {
    type: types.CHAT_UPDATE_LAST_MESSAGE_CONVERSATION_READ,
    mid,
    peerUserXmppId,
  };
}

export function updateLikevsFavoriteMutalSuccess(_isLikedMutual: boolean, _isFavoritedMutual: boolean): IAction {
  return {
    type: types.UPDATE_LIKE_OR_FAVORITE_MUTAL,
    isLikedMutual: _isLikedMutual,
    isFavoritedMutual: _isFavoritedMutual,
  };
}

export function toggleSelectPeerVCardStatus(status: boolean): IAction {
  return { type: types.UPDATE_SELECT_PEER_C_CARD_STATUS, data: !!status };
}

export function updateDraftMsg(data: any): IAction {
  return { type: types.UPDATE_DRAFT_MSG, data };
}

export function hiddenConversationLastMessageSuccess(id: string): IAction {
  return { type: types.HIDDEN_CONVERSATION_LAST_MESSAGE_SUCCESS, id };
}

export function patchIgnoreConversationSuccess(id: number, isIgnored: boolean): IAction {
  return { type: types.PATCH_IGNORE_CONVERSATION_SUCCESS, id, isIgnored };
}

export function patchIgnoreConversation(conversationId: number, isIgnored: boolean, isGroup: boolean = false) {
  return (dispatch: Dispatch, getState: any) => {
    const conversationSelected = getState().conversationsReducer.data.find((c: IConversation) => c.id === conversationId);
    if (conversationSelected) {
      const { xmppId } = conversationSelected.peerVcard;

      return conversationService
        .patchIgnoreConversation(isGroup ? xmppId : messageUtils.addPrefixAndSuffix(xmppId), isIgnored)
        .then(res => {
          dispatch(patchIgnoreConversationSuccess(conversationId, isIgnored));
          return res;
        });
    }
    return Promise.reject({ success: false });
  };
}

export function patchRulesGroupChat(params: any) {
  return (dispatch: Dispatch) => {
    dispatch(patchRulesGroupChatSuccess(params));
  };
}

export function updateGroupChatShouldBeSelected(roomJid: string): IAction {
  return { type: types.UPDATE_GROUP_CHAT_SHOULD_BE_SELECTED, data: roomJid };
}

export function updateRoomJidBeingJoined(roomJid: string): IAction {
  return { type: types.UPDATE_ROOM_JID_BEING_JOINED, data: roomJid };
}

export function clearJoinedSuccessRoomJid(): IAction {
  return { type: types.CLEAR_JOINED_SUCCESS_ROOM_JID };
}

export function removeRoomJidInJoinedSuccessRoomJids(data: string): IAction {
  return { type: types.REMOVE_ROOMJID_IN_JOINED_SUCCESS_ROOM_JIDS, data };
}

export function updateJoiningRoomJids(roomJids: string[]): IAction {
  return { type: types.UPDATE_JOINING_ROOM_JIDS, roomJids };
}

export function updateJoinedRoomJidsFailed(roomJid: string): IAction {
  return { type: types.UPDATE_JOINED_ROOM_JIDS_FAILED, roomJid };
}

export function updateJoinedPrivateGroupChat(roomJid: string): IAction {
  return { type: types.UPDATE_JOINED_PRIVATE_GROUP_CHAT, data: roomJid };
}

export function joinPrivateGroup(roomJid: string) {
  return (dispatch: Dispatch) => {
    dispatch(updateRoomJidBeingJoined(roomJid));
    if (roomJid && WebIM.conn.isOpened()) {
      WebIM.conn.joinChatRoom({
        roomJid,
        historyChat: false,
      });
    }
  };
}

export function updateIsActivePrivateRoomConversation(roomJid: string): IAction {
  return { type: types.UPDATE_IS_ACTIVE_PRIVATE_ROOM_CONVERSATION, roomJid };
}

export function addDataToScheduleRemoveConversation({ curNode, isGroup }: { curNode: any; isGroup: boolean }): IAction {
  return { type: types.ADD_DATA_TO_SCHEDULE_REMOVE_CONVERSATION, curNode, isGroup };
}

export function clearDataToScheduleRemoveConversation(): IAction {
  return { type: types.CLEAR_DATA_TO_SCHEDULE_REMOVE_CONVERSATION };
}

export function createUserPhotoBanner(convId: number, eventId: number, file: File) {
  return (dispatch: any) => {
    return conversationService.createUserPhotoBanner(convId, eventId, file).then((res: any) => {
      return res;
    });
  };
}

export function updateGroupCoverUrl(convId: number, coverUrl: string): IAction {
  return { type: types.UPDATE_CONVERSATION_GROUP_COVER_URL, data: { convId, coverUrl } };
}

export function updateConversationUserBoostExpiryTime(convId: number, time: number): IAction {
  return { type: types.UPDATE_CONVERSATION_USER_BOOST_EXPIRY_TIME, data: { convId, time } };
}

export function updateConversationBuddyBoostExpiryTime(convId: string, time: string): IAction {
  return { type: types.UPDATE_CONVERSATION_BUDDY_BOOST_EXPIRY_TIME, data: { convId, time } };
}

export function updateConversationsSearch(data: any): IAction {
  return { type: types.UPDATE_CONVERSATION_SEARCH, data };
}

export function resetConversationSearch() {
  return (dispatch: any, getState: any) => {
    const {
      defaultFilters: { minAge, maxAge, isVerified, isHasChangeFilter },
      defaultFilters,
    } = getState().conversationsReducer;

    const paramsUpdate = {
      filters: defaultFilters,
    };
    dispatch(updateConversationsSearch(paramsUpdate));
  };
}

export function updateStateConversationsSearch({ dataKey, data }: { dataKey: string[]; data: any }): IAction {
  return { type: types.UPDATE_STATE_CONVERSATION_SEARCH, dataKey, data };
}

export function getStateWithCountryId(countryId: string) {
  return (dispatch: any) => {
    return locationService.getLocation(countryId).then((res: any) => {
      dispatch(
        updateConversationsSearch({
          countrySelected: res.success ? countryId : null,
          locationState: res.success ? res.data : [],
        })
      );
      return res;
    });
  };
}

export function sendEventGroupChatMassMsg(params: { eventId: string | number; receivers: string[]; message: string }) {
  return (dispatch: any) => {
    return conversationService.sendEventGroupChatMassMsg(params).then(res => {
      return res;
    });
  };
}

export function updateUserOnlineStatus(data: any) {
  return { type: types.UPDATE_USERS_ONLINE_STATUS, data };
}

export function getUserOnlineStatus(data: IConversation[]) {
  let uIds = data
    .filter(item => !item.isGroup && (!item.peerVcard.isOnlineUpdateTime || checkTimeValid(item.peerVcard.isOnlineUpdateTime, 5)))
    .map(item => item.peerVcard.id);
  return (dispatch: any) => {
    return conversationService.getUsersStatus(uIds).then(res => {
      if (res.success && res.data?.length > 0) {
        const data = res.data.reduce(
          (obj: any, cur: { uid: number; online: boolean }) => ({ ...obj, [cur.uid]: { online: cur.online } }),
          {}
        );
        dispatch(updateUserOnlineStatus(data));
      }
      return res;
    });
  };
}
